export enum MobilePaymentType {
  EquipmentUpgrade = 'EquipmentUpgrade',
  PayNowWithSubscription = 'PayNowWithSubscription',
  PayNowWithoutSubscription = 'PayNowWithoutSubscription',
}

export enum MobilePaymentTypeName {
  EquipmentUpgrade = 'Mobilbytte',
  PayNowWithSubscription = 'Betal nå med abonnement',
  PayNowWithoutSubscription = 'Betal nå uten abonnement',
}
